import { defineStore } from 'pinia'

export const useLegalModalStore = defineStore('legalModal', {
  state: () => ({
    isModalVisible: false
  }),
  actions: {
    showModal() {
      this.isModalVisible = true
    },
    hideModal() {
      this.isModalVisible = false
    }
  }
})
